import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import { validaSoloNumero, 
    // validaNumeroTelefono, 
    validaEmail } from '../../util/varios';
/* import CatalogoPersona from '../../catalogos/catalogoPersona'; */
import { Mensaje } from '../../components/mensajes2';
import moment from 'moment';
import useTable from '../useTable'
import { Dimmer } from '../../components/spinner';

import AgregarConsejo from './modalAgregarConsejo';
import CatalogoPersona from '../../catalogos/catalogoPersona'
import { Toasts } from '../toasts'; 

const headCells = [
    { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'NOMBRES', textAlign: 'center' },
    { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'APELLIDOS', textAlign: 'center' },
    { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'OPCIONES', textAlign: 'center' },

]

export const Organizacion = (props) => {

    const btnAcepta = useRef();
    const txtCedulaPresupuesto = useRef();
    const txtCedulaAministracion = useRef();
    const txtCedulaRRHH = useRef();
    const txtCedulaSindico = useRef();
    const txtCedulaCronista = useRef();
    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [habilitadoNC, setHabilitadoNC] = useState("disabled");
    const [habilitadoNU, setHabilitadoNU] = useState(false);
    const [habilitadoBot, setHabilitadoBot] = useState(false);
    const [ciudad, setCiudad] = useState();
    // const [consejero, setConsejero] = useState()
    const [idOrganizacion, setIdOrganizacion] = useState()
    const [municipio, setMunicipio] = useState();
    const [estado, setEstado] = useState();
    const [mostrar3, setMostrar3] = useState(false);
    const [operacionPer, setOperacionPer] = useState(0);
    const [operacionCon, setOperacionCon] = useState(0);
    const [data, setData] = useState(false)
    const [tecla, setTecla] = useState();
    const [tipoPersona, setTipoPersona] = useState();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const accorganizacion = JSON.parse(localStorage.getItem('accorganizacion'));

    const [records, setRecords] = useState([]);
    const [consejoPlan, setConsejoPlan] = useState()
    const [mostrarConsejo, setMostrarConsejo] = useState(false);
    /* bloquear tab */
    const [tabIndex, setTabIndex] = useState(
        {
            tab1: 'tab',
            tab2: '',
            tab3: '',
            tab4: '',
            tab5: ''
        }

    );
    /* activar tab */
    const [activeTab, setACtiveTab] = useState(
        {
            tab1: 'rounded nav-link active bg-blue-100 text-light',
            tab2: 'rounded nav-link bg-blue-200 text-light',
            tab3: 'rounded nav-link bg-blue-300 text-light',
            tab4: 'rounded nav-link bg-blue-400 text-light',
            tab5: 'rounded nav-link bg-blue-500 text-light',
            tab6: 'rounded nav-link bg-blue-600 text-light'
        }
    );
    /* mostar tabPanel */
    const [tabPanel, setTabPanel] = useState(
        {
            tab1: 'tab-pane fade show active',
            tab2: 'tab-pane fade',
            tab3: 'tab-pane fade',
            tab4: 'tab-pane fade',
            tab5: 'tab-pane fade',
            tab6: 'tab-pane fade'
        }
    );
    /* validar tab */
    const [tabvalid, setTabValid] = useState(
        {
            tab1: 'true',
            tab2: 'false',
            tab3: 'false',
            tab4: 'false',
            tab5: 'false',
            tab6: 'false'

        }
    );

    const [presupuesto, setPresuesto] = useState({
        cedula: '',
        nombres: '',
        apellidos: '',
        direccion: '',
        correoe: '',
        tlf1: '',
        tlf2: '',
        fnacimiento: '',
        nacionalidad: '',
        sexo: ''
    })

    const [administracion, setAdministracion] = useState({
        cedula: '',
        nombres: '',
        apellidos: '',
        direccion: '',
        correoe: '',
        tlf1: '',
        tlf2: '',
        fnacimiento: '',
        nacionalidad: '',
        sexo: ''
    })

    const [recursos, setRecursos] = useState({
        cedula: '',
        nombres: '',
        apellidos: '',
        direccion: '',
        correoe: '',
        tlf1: '',
        tlf2: '',
        fnacimiento: '',
        nacionalidad: '',
        sexo: ''
    })

    const [sindicato, setSindicato] = useState({
        cedula: '',
        nombres: '',
        apellidos: '',
        direccion: '',
        correoe: '',
        tlf1: '',
        tlf2: '',
        fnacimiento: '',
        nacionalidad: '',
        sexo: ''
    })

    const [cronista, setCronista] = useState({
        cedula: '',
        nombres: '',
        apellidos: '',
        direccion: '',
        correoe: '',
        tlf1: '',
        tlf2: '',
        fnacimiento: '',
        nacionalidad: '',
        sexo: ''
    })


    // const [mostrarTab, setMostrarTab] = useState('true');
    const [operacion, setOperacion] = useState();
    const [toast, setToast] = useState({
        mostrar: false,
        mensaje: '',
        titulo: ''
    })
    const [organizacion, setOrganizacion] = useState('rounded nav-link');
    const [persona, setPersona] = useState({ cedula: '', nombres: '', apellidos: '', direccion: '', correoe: '', tlf1: '', tlf2: '', fnacimiento: '', nacionalidad: '', sexo: '' });
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const txtIdOrg = useRef();
    const txtRazonSoc = useRef();
    const txtNomOrg = useRef();
    const txtCodProv = useRef();
    const txtNomProv = useRef();
    const txtRifProv = useRef();
    const cmbRif = useRef();
    const txtRif = useRef();

    const txtNomContra = useRef();
    const txtApeContra = useRef();
    const txtDomiContra = useRef();
    const txtCorreContra = useRef();
    const txtTlfContra = useRef();
    const txtFaxContra = useRef();
    const txtPagWebContra = useRef();

    const cmbNacPresu = useRef();
    const cmbSexPresu = useRef();
    const cmbNacAdmin = useRef();
    const cmbSexAdmin = useRef();
    const cmbNacRecur = useRef();
    const cmbSexRecur = useRef();
    const cmbNacSindi = useRef();
    const cmbSexSindi = useRef();
    const cmbNacCroni = useRef();
    const cmbSexCroni = useRef();

    const txtNomPre = useRef();
    const txtApePre = useRef();
    const txtNomSecr = useRef();
    const txtApeSecr = useRef();
    const txtDomiMunicipal = useRef();
    const txtCorreMunicipal = useRef();
    const txtTlfMunicipal = useRef();
    const txtFaxMunicipal = useRef();
    const txtPagMunicipal = useRef();


    const txtDomicilio = useRef();
    const cmbEstado = useRef();
    const cmbMunicipio = useRef();
    const cmbCiudad = useRef();
    const txtEmailOrg = useRef();
    const txtBaseL = useRef();
    const txtTlfOrg = useRef();
    const txtCelOrg = useRef();
    const txtFaxOrg = useRef();
    const txtPagWeb = useRef();
    const txtMision = useRef();
    const txtPrincipios = useRef();
    const txtVision = useRef();
    const txtCodPostal = useRef();
    const txtCedula = useRef();
    const txtNombreRespon = useRef();
    const txtApellidoRespon = useRef();
    const txtDireccionRespon = useRef();
    const txtEmailRespon = useRef();
    const txtTlfRespon = useRef();
    const txtCelRespon = useRef();
    const txtFechaNac = useRef();
    const cmbNacionalidad = useRef();
    const txtCodPresu = useRef();
    const cmbSexo = useRef();

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    useEffect(() => {
        seleccionarOrganizacion();
        CatalogoEstado();

        let obj = JSON.parse(localStorage.getItem('post'));
        setFechaSistema(moment.utc(obj.fechasistema).format('YYYY-MM-DD'));
        setDeshabilitado(true);
    }, []);

    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTable(records, headCells, filterFn);


    const validarRif = (event) => {
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                setActivate(true);
                let endpoint = op.seniat + '/rif=' + cmbRif + txtRif.current.value;
                axios.get(endpoint).then(function (response) {
                    if (response.status == 200) {
                        response.data.rif === 'error de conexion al seniat' ? (
                        setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Error interno de Conexión', icono: 'informacion' }),
                        txtDomicilio.current.focus()) :
                        (txtRif.current.value = response.data.rif,
                        setHabilitadoNC("disabled"))
                    }
                })
                .catch(function (err) {
                    if (err) {

                        txtDomicilio.current.focus();
                    }
                })
                .then(function () {
                    setActivate(false);
                });
            } else { }
        }
    }

    const CatalogoEstado = () => {
        let endpoint = `${op.conexion}/api/catalogo/estado`;
        setActivate(true);
        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        }})
        .then(function (response) {
            if (response.status == 200) {
                setEstado(response.data);
                setActivate(false);
            }
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    }

    const seleccionarCiudad = (municipio, ciudad) => {
        let campos = '*';
        let nomtab = 'ciudad';
        let nomid = 'idmunicipio';
        let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${municipio}&nomtab=${nomtab}&nomid=${nomid}`;

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        }})
        .then(function (response) {
            if (response.status == 200) {
                if (response.data.length > 0) {
                    setCiudad(response.data);
                    cmbCiudad.current.value = ciudad;
                }
            }
            setActivate(false);
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    }
    const seleccionarMunicipio = (estado, municipio, ciudad) => {
        setActivate(true);
        let campos = '*';
        let nomtab = 'municipio';
        let nomid = 'idestado';
        let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${estado}&nomtab=${nomtab}&nomid=${nomid}`;
        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        }})
        .then(function (response) {
            if (response.status == 200) {
                if (response.data.length > 0) {
                    setMunicipio(response.data);
                    cmbMunicipio.current.value = municipio;
                    seleccionarCiudad(municipio, ciudad)
                }
            }
            setActivate(false);
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    }

    const editarOrganizacion = (op, per) => (event) => {
        event.preventDefault();
        if (per.toString() === '1') {
            setOperacion(op)
            setDeshabilitado(false);
            setHabilitadoBot(true);
            setHabilitadoNU(false);
        } else {
            setToast({
                mostrar: true,
                mensaje: 'No posee permiso para este modulo',
                titulo: 'Alerta.'
            })
        }
    };

    const selectProveedor = (id) => {
        let campos = 'razonsocial,rif';
        let nomtab = 'proveedor';
        let nomid = 'idproveedor';
        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'
        }})
        .then(function (response) {
            if (response.status == 200) {
                txtNomProv.current.value = response.data.razonsocial;
                txtRifProv.current.value = response.data.rif;
            }
            setActivate(false);
        })
        .catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
        })
    }

    const selectPresupuesto = (cedula) => {
        let campos = 'cedula,nombres,apellidos,direccion,correoe,tlf1,tlf2,fnacimiento,nacionalidad,sexo';
        let nomtab = 'persona';
        let nomid = 'cedula';
        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
        setActivate(true);
        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'
        }})
        .then(function (response) {
            if (response.status == 200) {
                setPresuesto(response.data)
                cmbNacPresu.current.value = response.data.nacionalidad;
                cmbSexPresu.current.value = response.data.sexo;
            }
            setActivate(false);
        })
        .catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
        })
    }
    const selectAdmin = (cedula) => {
        let campos = 'cedula,nombres,apellidos,direccion,correoe,tlf1,tlf2,fnacimiento,nacionalidad,sexo';
        let nomtab = 'persona';
        let nomid = 'cedula';

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'
        }})
        .then(function (response) {
            if (response.status == 200) {
                setAdministracion(response.data)
                cmbNacAdmin.current.value = response.data.nacionalidad;
                cmbSexAdmin.current.value = response.data.sexo;
            }
            setActivate(false);
        }).catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
        })
    }
    const selectRecursosH = (cedula) => {
        let campos = 'cedula,nombres,apellidos,direccion,correoe,tlf1,tlf2,fnacimiento,nacionalidad,sexo';
        let nomtab = 'persona';
        let nomid = 'cedula';

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        }})
        .then(function (response) {
            if (response.status == 200) {
                setRecursos(response.data)
                cmbNacRecur.current.value = response.data.nacionalidad;
                cmbSexRecur.current.value = response.data.sexo;
            }
            setActivate(false);
        })
        .catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
        })
    }

    const selectSindicatura = (cedula) => {
        let campos = 'cedula,nombres,apellidos,direccion,correoe,tlf1,tlf2,fnacimiento,nacionalidad,sexo';
        let nomtab = 'persona';
        let nomid = 'cedula';

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'
        }})
        .then(function (response) {
            if (response.status == 200) {
                setSindicato(response.data);
                cmbNacSindi.current.value = response.data.nacionalidad;
                cmbSexSindi.current.value = response.data.sexo;
            }
            setActivate(false);
        })
        .catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
        })

    }

    const selectCronista = (cedula) => {

        let campos = 'cedula,nombres,apellidos,direccion,correoe,tlf1,tlf2,fnacimiento,nacionalidad,sexo';
        let nomtab = 'persona';
        let nomid = 'cedula';

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        }})
        .then(function (response) {
            if (response.status == 200) {
                setCronista(response.data);
                cmbNacCroni.current.value = response.data.nacionalidad;
                cmbSexCroni.current.value = response.data.sexo;
            }
            setActivate(false);
        })
        .catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
        })
    }

    const selectResponsable = (cedula) => {
        let campos = '*';
        let nomtab = 'persona';
        let nomid = 'cedula';

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'
        }})
        .then(function (response) {
            if (response.status == 200) {
                txtCedula.current.value = cedula;
                txtNombreRespon.current.value = response.data.nombres;
                txtApellidoRespon.current.value = response.data.apellidos;
                txtDireccionRespon.current.value = response.data.direccion;
                txtEmailRespon.current.value = response.data.correoe;
                txtTlfRespon.current.value = response.data.tlf1;
                txtCelRespon.current.value = response.data.tlf2;
                txtFechaNac.current.value = moment.utc(response.data.fnacimiento).format('YYYY-MM-DD');
                cmbNacionalidad.current.value = response.data.nacionalidad;
                cmbSexo.current.value = response.data.sexo;
            }
            setActivate(false);
        })
        .catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
        })
    }
    const selectConsePlanificacion = (id) => {
        let endpoint = `${op.conexion}/api/configuracion/planificacionorg?id=${id}`;
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'
        }})
        .then(function (response) {
            if (response.status == 200) {
                setRecords(response.data)
            }
            setActivate(false);
        }).catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
        })
    }

    const seleccionarOrganizacion = () => {
        setActivate(true);
        let endpoint = `${op.conexion}/api/comun/organizacion`;
        console.log(endpoint)
        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'
        }})
        .then((response) => {
            if (response.status == 200) {
                if (response.data[0] !== '') {
                    setData(true)
                    setIdOrganizacion(response.data[0].idorganizacion)
                    txtIdOrg.current.value = response.data[0].idorganizacion;
                    txtRazonSoc.current.value = response.data[0].razonsocial.trim();
                    txtNomOrg.current.value = response.data[0].nombre.trim();
                    txtCodPostal.current.value = response.data[0].codpostal.trim();
                    txtDomicilio.current.value = response.data[0].domicilio.trim();
                    txtBaseL.current.value = response.data[0].baselegal.trim();
                    txtCodProv.current.value = response.data[0].idproveedor.trim()
                    txtCodPresu.current.value = response.data[0].codpresu.trim();
                    cmbRif.current.value = isNaN(response.data[0].rif.substring(0, 1)) ? response.data[0].rif.substring(0, 1) : '';
                    txtRif.current.value = isNaN(response.data[0].rif.substring(0, 1)) ? response.data[0].rif.substring(1, response.data[0].rif.trim().length) : !isNaN(response.data[0].rif.substring(0, 1)) ? response.data[0].rif.substring(0, response.data[0].rif.trim().length) : '';
                    txtEmailOrg.current.value = response.data[0].correoe === null ? response.data[0].correoe : response.data[0].correoe.trim();
                    txtTlfOrg.current.value = response.data[0].tlf1 === null ? response.data[0].tlf1 : response.data[0].tlf1.trim();
                    txtCelOrg.current.value = response.data[0].tlf2 === null ? response.data[0].tlf2 : response.data[0].tlf2.trim();
                    txtFaxOrg.current.value = response.data[0].fax === null ? response.data[0].fax : response.data[0].fax.trim();
                    txtPagWeb.current.value = response.data[0].pagweb === null ? response.data[0].pagweb : response.data[0].pagweb.trim();
                    txtMision.current.value = response.data[0].mision === null ? response.data[0].mision : response.data[0].mision.trim();
                    txtPrincipios.current.value = response.data[0].principios === null ? response.data[0].principios : response.data[0].principios.trim();
                    txtVision.current.value = response.data[0].vision === null ? response.data[0].vision : response.data[0].vision.trim();
                    cmbCiudad.current.value = response.data[0].idciudad;
                    cmbMunicipio.current.value = response.data[0].idmunicipio;
                    cmbEstado.current.value = response.data[0].idestado;
                    txtNomContra.current.value = response.data[0].nombrecontralor;
                    txtApeContra.current.value = response.data[0].apellidocontralor;
                    txtDomiContra.current.value = response.data[0].direcontraloria;
                    txtCorreContra.current.value = response.data[0].correoecontraloria;
                    txtTlfContra.current.value = response.data[0].tlfcontraloria;
                    txtFaxContra.current.value = response.data[0].faxcontraloria;
                    txtPagWebContra.current.value = response.data[0].pagwebcontraloria;

                    txtNomPre.current.value = response.data[0].nombpresideconsejo;
                    txtApePre.current.value = response.data[0].apepresideconsejo;
                    txtNomSecr.current.value = response.data[0].nombsecreconsejo;
                    txtApeSecr.current.value = response.data[0].apesecreconsejo;
                    txtDomiMunicipal.current.value = response.data[0].direconsejo;
                    txtCorreMunicipal.current.value = response.data[0].correoeconsejo;
                    txtTlfMunicipal.current.value = response.data[0].tlfconsejo;
                    txtFaxMunicipal.current.value = response.data[0].faxconsejo;
                    txtPagMunicipal.current.value = response.data[0].pagwebconsejo

                    selectProveedor(response.data[0].idproveedor);

                    cmbEstado.current.value = parseInt(response.data[0].idestado);
                    seleccionarMunicipio(response.data[0].idestado, response.data[0].idmunicipio, response.data[0].idciudad);

                    selectResponsable(response.data[0].cedularesponsable)
                    selectPresupuesto(response.data[0].cedulapresu)
                    selectAdmin(response.data[0].cedulaadmin)
                    selectRecursosH(response.data[0].cedularrhh)
                    selectSindicatura(response.data[0].cedulasindi)
                    selectCronista(response.data[0].cedulacroni)
                    selectConsePlanificacion(response.data[0].idorganizacion)

                    setActivate(false);
                } else {
                    setData(false)
                }
            }
            setActivate(false);
        }).catch((error) => {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    };

    const cancelar = () => (event) => {
        setTabIndex({ tab1: 'tab', tab2: '' })
        event.preventDefault();
        blanquear();
    };

    const blanquear = () => {
        setDeshabilitado(true);
        setHabilitadoBot(false);
    };

    const onChange = (event) => {
        if (event.target.name === 'idestado') {
            cmbEstado.current.value = event.target.value;
            setMunicipio();
            setCiudad();
            if (event.target.value !== '') {
                seleccionarMunicipio(event.target.value, '')
            }
        } else if (event.target.name === 'idmunicipio') {
            cmbMunicipio.current.value = event.target.value
            setCiudad();
            if (event.target.value !== '') {
                seleccionarCiudad(event.target.value, '')
            }
        } else if (event.target.name === 'idciudad') {
            cmbCiudad.current.value = event.target.value
        }
    };

    const handleAceptaCatalogoPer = (cedPer, nomPer, apePer, correoPer, tlf1Per,
        tlf2Per, fnacPer, nacPer, sexoPer, direPer) => {
        setMostrar3(false);

        if (parseInt(tipoPersona) === 1) {
            txtCedula.current.value = cedPer;
            txtNombreRespon.current.value = nomPer;
            txtApellidoRespon.current.value = apePer;
            txtDireccionRespon.current.value = direPer;
            txtEmailRespon.current.value = correoPer;
            txtTlfRespon.current.value = tlf1Per;
            txtCelRespon.current.value = tlf2Per;
            txtFechaNac.current.value = moment.utc(fnacPer).format('YYYY-MM-DD');
            cmbNacionalidad.current.value = nacPer;
            cmbSexo.current.value = sexoPer;
        } else if (parseInt(tipoPersona) === 2) {
            setPresuesto({
                cedula: cedPer,
                nombres: nomPer,
                apellidos: apePer,
                direccion: direPer,
                correoe: correoPer,
                tlf1: tlf1Per,
                tlf2: tlf2Per,
                fnacimiento: moment.utc(fnacPer).format('YYYY-MM-DD'),
            })
            cmbNacPresu.current.value = nacPer;
            cmbSexPresu.current.value = sexoPer;
        } else if (parseInt(tipoPersona) === 3) {
            setAdministracion({
                cedula: cedPer,
                nombres: nomPer,
                apellidos: apePer,
                direccion: direPer,
                correoe: correoPer,
                tlf1: tlf1Per,
                tlf2: tlf2Per,
                fnacimiento: moment.utc(fnacPer).format('YYYY-MM-DD'),
            })
            cmbNacAdmin.current.value = nacPer;
            cmbSexAdmin.current.value = sexoPer;
        } else if (parseInt(tipoPersona) === 4) {
            setRecursos({
                cedula: cedPer,
                nombres: nomPer,
                apellidos: apePer,
                direccion: direPer,
                correoe: correoPer,
                tlf1: tlf1Per,
                tlf2: tlf2Per,
                fnacimiento: moment.utc(fnacPer).format('YYYY-MM-DD'),
            })
            cmbNacRecur.current.value = nacPer;
            cmbSexRecur.current.value = sexoPer;

        } else if (parseInt(tipoPersona) === 5) {

            setSindicato({
                cedula: cedPer,
                nombres: nomPer,
                apellidos: apePer,
                direccion: direPer,
                correoe: correoPer,
                tlf1: tlf1Per,
                tlf2: tlf2Per,
                fnacimiento: moment.utc(fnacPer).format('YYYY-MM-DD'),
            })
            cmbNacSindi.current.value = nacPer;
            cmbSexSindi.current.value = sexoPer;

        } else if (parseInt(tipoPersona) === 6) {

            setCronista({
                cedula: cedPer,
                nombres: nomPer,
                apellidos: apePer,
                direccion: direPer,
                correoe: correoPer,
                tlf1: tlf1Per,
                tlf2: tlf2Per,
                fnacimiento: moment.utc(fnacPer).format('YYYY-MM-DD'),
            })
            cmbNacCroni.current.value = nacPer;
            cmbSexCroni.current.value = sexoPer;
        }
    }

    const catalogoPer = (tiper) => (e) => {
        e.preventDefault();
        setTipoPersona(tiper)
        setMostrar3(true);
    };

    const validarPersona = (num) => (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        setTipoPersona(num)
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                setTecla(event.which);
                datosRes(event.target.value);
            } else {
                txtNombreRespon.current.value = '';
            }
        }
    };

    const datosRes = (cedula) => {
        let campos = '*';
        let nomtab = 'persona';
        let nomid = 'cedula';
        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
        setActivate(true);
        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'
        }})
        .then(function (response) {
            if (response.status == 200) {
                setHabilitadoNU(true);
                txtNombreRespon.current.value = '';
                txtApellidoRespon.current.value = '';
                txtDireccionRespon.current.value = '';
                txtEmailRespon.current.value = '';
                txtTlfRespon.current.value = '';
                txtCelRespon.current.value = '';
                txtFechaNac.current.value = '';
                cmbNacionalidad.current.value = 'V';
                cmbSexo.current.value = 'M';
                if (response.data !== '') {
                    setHabilitadoNU(false);
                    setOperacionPer(0);
                    if (parseInt(tipoPersona) === 1) {
                        txtNombreRespon.current.value = response.data.nombres;
                        txtApellidoRespon.current.value = response.data.apellidos;
                        txtDireccionRespon.current.value = response.data.direccion;
                        txtEmailRespon.current.value = response.data.correoe;
                        txtTlfRespon.current.value = response.data.tlf1;
                        txtCelRespon.current.value = response.data.tlf2;
                        txtFechaNac.current.value = moment.utc(response.data.fnacimiento).format('YYYY-MM-DD');
                        cmbNacionalidad.current.value = response.data.nacionalidad;
                        cmbSexo.current.value = response.data.sexo;
                    } else if (parseInt(tipoPersona) === 2) {
                        setPresuesto({
                            cedula: cedula,
                            nombres: response.data.nombres,
                            apellidos: response.data.apellidos,
                            direccion: response.data.direccion,
                            correoe: response.data.correoe,
                            tlf1: response.data.tlf1,
                            tlf2: response.data.tlf2,
                            fnacimiento: moment.utc(response.data.fnacimiento).format('YYYY-MM-DD'),
                        })
                        cmbNacPresu.current.value = response.data.nacionalidad;
                        cmbSexPresu.current.value = response.data.sexo;
                    } else if (parseInt(tipoPersona) === 3) {
                        setAdministracion({
                            cedula: cedula,
                            nombres: response.data.nombres,
                            apellidos: response.data.apellidos,
                            direccion: response.data.direccion,
                            correoe: response.data.correoe,
                            tlf1: response.data.tlf1,
                            tlf2: response.data.tlf2,
                            fnacimiento: moment.utc(response.data.fnacimiento).format('YYYY-MM-DD'),
                        })
                        cmbNacAdmin.current.value = response.data.nacionalidad;
                        cmbSexAdmin.current.value = response.data.sexo;
                    } else if (parseInt(tipoPersona) === 4) {
                        setRecursos({
                            cedula: cedula,
                            nombres: response.data.nombres,
                            apellidos: response.data.apellidos,
                            direccion: response.data.direccion,
                            correoe: response.data.correoe,
                            tlf1: response.data.tlf1,
                            tlf2: response.data.tlf2,
                            fnacimiento: moment.utc(response.data.fnacimiento).format('YYYY-MM-DD'),
                        })
                        cmbNacRecur.current.value = response.data.nacionalidad;
                        cmbSexRecur.current.value = response.data.sexo;
                    } else if (parseInt(tipoPersona) === 5) {
                        setSindicato({
                            cedula: cedula,
                            nombres: response.data.nombres,
                            apellidos: response.data.apellidos,
                            direccion: response.data.direccion,
                            correoe: response.data.correoe,
                            tlf1: response.data.tlf1,
                            tlf2: response.data.tlf2,
                            fnacimiento: moment.utc(response.data.fnacimiento).format('YYYY-MM-DD'),
                        })
                        cmbNacSindi.current.value = response.data.nacionalidad;
                        cmbSexSindi.current.value = response.data.sexo;
                    } else if (parseInt(tipoPersona) === 6) {
                        setCronista({
                            cedula: cedula,
                            nombres: response.data.nombres,
                            apellidos: response.data.apellidos,
                            direccion: response.data.direccion,
                            correoe: response.data.correoe,
                            tlf1: response.data.tlf1,
                            tlf2: response.data.tlf2,
                            fnacimiento: moment.utc(response.data.fnacimiento).format('YYYY-MM-DD'),
                        })
                        cmbNacCroni.current.value = response.data.nacionalidad;
                        cmbSexCroni.current.value = response.data.sexo;
                    }
                    if (tecla === 13) {
                        btnAcepta.current.focus();
                    }
                } else {
                    setOperacionPer(1);
                    setHabilitadoNU(true);
                    if (tecla === 13) {
                        setTimeout(() => {
                            txtNombreRespon.current.focus();
                        }, 100);
                    }
                }
            }
            setActivate(false);
        }).catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
        })
    };

    const handleInputNumChange = (event) => {
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {} 
        else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const handleInputChange = (event) => {
        if (event.which === 13) {
            var valido;
            if (event.target.id === 'inputRazonSoc') {
                txtNomOrg.current.focus();
            } else if (event.target.id === 'inputNombre') {
                cmbRif.current.focus();
            } else if (event.target.id === 'inputRif') {
                txtDomicilio.current.focus();
            } else if (event.target.id === 'inputDomicilio') {
                cmbEstado.current.focus();
            } else if (event.target.id === 'inputEmailOrg') {
                txtTlfOrg.current.focus();
            } else if (event.target.id === 'inputTlfOrg') {
                txtCelOrg.current.focus();
            } else if (event.target.id === 'inputCelOrg') {
                txtFaxOrg.current.focus();
            } else if (event.target.id === 'inputFaxOrg') {
                txtPagWeb.current.focus();
            } else if (event.target.id === 'inputPagWeb') {
                txtMision.current.focus();
            } else if (event.target.id === 'inputMision') {
                txtPrincipios.current.focus();
            } else if (event.target.id === 'inputPrincipios') {
                txtVision.current.focus();
            } else if (event.target.id === 'inputVision') {
                txtCedula.current.focus();
            } else if (event.target.id === 'inputNombreRespon') {
                txtApellidoRespon.current.focus();
            } else if (event.target.id === 'inputApellidoRespon') {
                txtDireccionRespon.current.focus();
            } else if (event.target.id === 'inputEmailRespon') {
                valido = validaEmail(event.target.value);
                if (valido) {
                    txtTlfRespon.current.focus();
                } else {
                    if (event.target.value !== '') {
                        setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'Formato de Email invalido.', icono: 'informacion' });
                        event.target.value = '';
                    } else {
                        txtTlfRespon.current.focus();
                    }
                }
            } else if (event.target.id === 'inputTlfRespon') {
                txtCelRespon.current.focus();
            } else if (event.target.id === 'inputCelRespon') {
                txtFechaNac.current.focus();
            } else if (event.target.id === 'inputFechaNac') {
                cmbNacionalidad.current.focus();
            }
        } else if (typeof (event.which) === 'undefined') {
            if (event.target.id === 'inputEmailOrg') {
                valido = validaEmail(event.target.value);
                if (valido) {
                    txtTlfOrg.current.focus();
                } else {
                    if (event.target.value !== '') {
                        event.target.value = '';
                    } else {
                        txtTlfOrg.current.focus();
                    }
                }

            } else if (event.target.id === 'inputTlfOrg') {
                txtCelOrg.current.focus();
            } else if (event.target.id === 'inputCelOrg') {
                txtFaxOrg.current.focus();
            } else if (event.target.id === 'inputEmailRespon') {
                valido = validaEmail(event.target.value);
                if (valido) {
                    txtTlfRespon.current.focus();
                } else {
                    if (event.target.value !== '') {
                        event.target.value = '';
                    } else {
                        txtTlfRespon.current.focus();
                    }
                }

            } else if (event.target.id === 'inputTlfRespon') {
                txtCelRespon.current.focus();
            } else if (event.target.id === 'inputCelRespon') {
                txtFechaNac.current.focus();
            } else {
                return false;
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        var mensaje = '';
        if (txtRazonSoc.current.value.trim() === '') {
            sigue = false;
            mensaje = 'La Razon Social no debe estar vacia';
            setTabIndex(0);
            txtRazonSoc.current.focus();
        } else if (txtNomOrg.current.value.trim() === '') {
            cmbNacionalidad
            mensaje = 'El Nombre de la Organizacion no debe estar vacio';
            sigue = false;
            setTabIndex(0);
            txtNomOrg.current.focus();
        } else if (txtRif.current.value.trim() === '') {
            mensaje = 'El Rif de la Organizacion no debe estar vacio';
            sigue = false;
            setTabIndex(0);
            txtRif.current.focus();
        } else if (txtDomicilio.current.value.trim() === '') {
            mensaje = 'El Domicilio de la Organizacion no debe estar vacio';
            sigue = false;
            setTabIndex(0);
            txtDomicilio.current.focus();
        } else if (cmbEstado.current.value.trim() === '') {
            mensaje = 'Por Favor Seleccione el Estado';
            sigue = false;
            setTabIndex(0);
            cmbEstado.current.focus();
        } else if (cmbMunicipio.current.value.trim() === '') {
            mensaje = 'Por Favor Seleccione el Municipio';
            sigue = false;
            setTabIndex(0);
            cmbMunicipio.current.focus();
        } else if (cmbCiudad.current.value.trim() === '') {
            mensaje = 'Por Favor Seleccione la Ciudad';
            sigue = false;
            setTabIndex(0);
            cmbCiudad.current.focus();
        } else if (txtCedula.current.value.trim() === '') {
            mensaje = 'La cedula no debe estar vacia';
            sigue = false;
            setTabIndex({ tab1: 'tab', ...tabIndex })
            setTabIndex({ tab1: 'tab', ...tabIndex })
            setACtiveTab({ tab1: 'rounded nav-link bg-blue-100 text-light', tab2: 'rounded nav-link active bg-blue-200 text-light', tab3: 'rounded nav-link bg-blue-300 text-light', tab4: 'rounded nav-link bg-blue-400 text-light' })
            setTabValid({ tab1: 'false', tab2: 'true', tab3: 'false', tab4: 'false' })
            setTabPanel({ tab1: 'tab-pane fade', tab2: 'tab-pane fade show active', tab3: 'tab-pane fade', tab4: 'tab-pane fade' })
            txtCedula.current.focus();
        } else if (txtNombreRespon.current.value.trim() === '') {
            mensaje = 'Los nombres no deben estar vacios';
            sigue = false;
            setTabIndex({ tab1: '', tab2: 'tab', tab3: '', tab4: '' })
            setTabIndex({ tab1: 'tab', ...tabIndex })
            setACtiveTab({ tab1: 'rounded nav-link bg-blue-100 text-light', tab2: 'rounded nav-link active bg-blue-200 text-light', tab3: 'rounded nav-link bg-blue-300 text-light', tab4: 'rounded nav-link bg-blue-400 text-light', })
            setTabValid({ tab1: 'false', tab2: 'true' })
            setTabPanel({ tab1: 'tab-pane fade', tab2: 'tab-pane fade show active', tab3: 'tab-pane fade', tab4: 'tab-pane fade' })
            txtNombreRespon.current.focus();
        } else if (txtApellidoRespon.current.value.trim() === '') {
            mensaje = 'Los Apellidos no deben estar vacio';
            sigue = false;
            setTabIndex({ tab1: '', tab2: 'tab' })
            setTabIndex({ tab1: 'tab', ...tabIndex })
            setACtiveTab({ tab1: 'rounded nav-link bg-blue-100 text-light', tab2: 'rounded nav-link active bg-blue-200 text-light', tab3: 'rounded nav-link bg-blue-300 text-light', tab4: 'rounded nav-link bg-blue-400 text-light', })
            setTabValid({ tab1: 'false', tab2: 'true' })
            setTabPanel({ tab1: 'tab-pane fade', tab2: 'tab-pane fade show active', tab3: 'tab-pane fade', tab4: 'tab-pane fade' })
            setTabIndex(1);
            txtApellidoRespon.current.focus();
        } else if (txtDireccionRespon.current.value.trim() === '') {
            mensaje = 'La direccion del Responsable no debe estar vacia';
            sigue = false;
            setTabIndex({ tab1: '', tab2: 'tab' })
            setTabIndex({ tab1: 'tab', ...tabIndex })
            setACtiveTab({ tab1: 'rounded nav-link bg-blue-100 text-light', tab2: 'rounded nav-link active bg-blue-200 text-light', tab3: 'rounded nav-link bg-blue-300 text-light', tab4: 'rounded nav-link bg-blue-400 text-light', })
            setTabValid({ tab1: 'false', tab2: 'true' })
            setTabPanel({ tab1: 'tab-pane fade', tab2: 'tab-pane fade show active', tab3: 'tab-pane fade', tab4: 'tab-pane fade' })

            setTabIndex(1);
            txtDireccionRespon.current.focus();
        } else if (txtFechaNac.current.value.trim() === '') {
            mensaje = 'La fecha de nacimiento no debe estar vacia';
            sigue = false;
            setTabIndex({ tab1: '', tab2: 'tab' })
            setTabIndex({ tab1: 'tab', ...tabIndex })
            setACtiveTab({ tab1: 'rounded nav-link bg-blue-100 text-light', tab2: 'rounded nav-link active bg-blue-200 text-light', tab3: 'rounded nav-link bg-blue-300 text-light', tab4: 'rounded nav-link bg-blue-400 text-light', })
            setTabValid({ tab1: 'false', tab2: 'true' })
            setTabPanel({ tab1: 'tab-pane fade', tab2: 'tab-pane fade show active', tab3: 'tab-pane fade', tab4: 'tab-pane fade' })

            setTabIndex(1);
            txtFechaNac.current.focus();
        }

        if (sigue) {

            var org = [];
            var datoPer = [];

            setOrganizacion(org);
            setPersona(datoPer);
            setActivate(true);
            let body = {
                operacion: operacion,
                id: txtIdOrg.current.value,
                cciudad: cmbCiudad.current.value,
                crsocial: txtRazonSoc.current.value,
                cnombre: txtNomOrg.current.value,
                cdomicilio: txtDomicilio.current.value,
                ctlf1: txtTlfOrg.current.value,
                ctlf2: txtCelOrg.current.value,
                cfax: txtFaxOrg.current.value,
                ccorreoe: txtEmailOrg.current.value,
                cmision: txtMision.current.value,
                cprincipios: txtPrincipios.current.value,
                cvision: txtVision.current.value,
                cpagweb: txtPagWeb.current.value,
                crif: cmbRif.current.value + txtRif.current.value,
                enc: parseInt(txtCedula.current.value),
                idprove: txtCodProv.current.value,
                operacionper: operacionPer,
                cor: txtEmailRespon.current.value,
                ctlfo1: txtTlfRespon.current.value,
                ctlfo2: txtCelRespon.current.value,
                ape: txtApellidoRespon.current.value,
                dir: txtDireccionRespon.current.value,
                fnac: txtFechaNac.current.value,
                nac: cmbNacionalidad.current.value,
                nombres: txtNombreRespon.current.value,
                sex: cmbSexo.current.value,
                ccodpre: txtCodPresu.current.value,
                cbasele: txtBaseL.current.value,
                cedpresu: txtCedulaPresupuesto.current.value,
                cedadmi: txtCedulaAministracion.current.value,
                cedrrhh: txtCedulaRRHH.current.value,
                cedsindi: txtCedulaSindico.current.value,
                cedcroni: txtCedulaCronista.current.value,
                datcantra: [txtNomContra.current.value,
                txtApeContra.current.value,
                txtDomiContra.current.value,
                txtTlfContra.current.value,
                txtFaxContra.current.value,
                txtCorreContra.current.value,
                txtPagWebContra.current.value],
                datconsejo: [txtNomPre.current.value,
                txtApePre.current.value,
                txtNomSecr.current.value,
                txtApeSecr.current.value,
                txtDomiMunicipal.current.value,
                txtTlfMunicipal.current.value,
                txtFaxMunicipal.current.value,
                txtCorreMunicipal.current.value,
                txtPagMunicipal.current.value],
                ccodpos: txtCodPostal.current.value,
                //consejero: JSON.stringify(consejero)
            };
            procesarRegistro(body);
        } else {
            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: mensaje, icono: 'informacion' });
            setTimeout(() => {
                txtNombreRespon.current.focus();
            }, 500);
        }
    };

    const procesarRegistro = (body) => {
        let endpoint = `${op.conexion}/api/configuracion/actualizarorg`;
        axios.post(endpoint, body, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'
        }})
        .then(function (response) {
            if (response.status == 200) {
                setActivate(false);
                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'La Organizacion ' + txtIdOrg.current.value + ' ha sido actualizada de manera satisfactoria.', icono: 'exito' });
                blanquear();
            }
        })
        .catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
        })
    }

    const tabs = (vl) => (e) => {
        e.preventDefault()
        if (vl == 1) {
            setACtiveTab({ tab1: 'rounded nav-link bg-blue-100 text-light active ', tab2: 'rounded nav-link bg-blue-200 text-light', tab3: 'rounded nav-link bg-blue-300 text-light', tab4: 'rounded nav-link bg-blue-400 text-light', tab5: 'rounded nav-link bg-blue-500 text-light active ', tab6: 'rounded nav-link bg-blue-600 text-light ' })
            setTabValid({ tab1: 'true', tab2: 'false', tab3: 'false', tab4: 'false', tab5: 'false', tab6: 'false' })
            setTabPanel({ tab1: 'tab-pane fade show active ', tab2: 'tab-pane fade ', tab3: 'tab-pane fade ', tab4: 'tab-pane fade ', tab5: 'tab-pane fade ', tab6: 'tab-pane fade ' })
        } else if (vl === 2) {
            setACtiveTab({ tab1: 'rounded nav-link bg-blue-100 text-light', tab2: 'rounded nav-link active bg-blue-200 text-light', tab3: 'rounded nav-link bg-blue-300 text-light', tab4: 'rounded nav-link bg-blue-400 text-light', tab5: 'rounded nav-link bg-blue-500 text-light active ', tab6: 'rounded nav-link bg-blue-600 text-light ' })
            setTabValid({ tab1: 'false', tab2: 'true', tab3: 'false', tab4: 'false', tab5: 'false', tab6: 'false' })
            setTabPanel({ tab1: 'tab-pane fade ', tab2: 'tab-pane fade show active ', tab3: 'tab-pane fade ', tab4: 'tab-pane fade ', tab5: 'tab-pane fade ', tab6: 'tab-pane fade ' })

        } else if (vl === 3) {
            setACtiveTab({ tab1: 'rounded nav-link bg-blue-100 text-light', tab2: 'rounded nav-link  bg-blue-200 text-light', tab3: 'rounded nav-link bg-blue-100 text-light active ', tab4: 'rounded nav-link bg-blue-400 text-light', tab5: 'rounded nav-link bg-blue-500 text-light ', tab6: 'rounded nav-link bg-blue-600 text-light ' })
            setTabValid({ tab1: 'false', tab2: 'false', tab3: 'true', tab4: 'false', tab5: 'false', tab6: 'false' })
            setTabPanel({ tab1: 'tab-pane fade ', tab2: 'tab-pane fade ', tab3: 'tab-pane fade show active', tab4: 'tab-pane fade ', tab5: 'tab-pane fade ', tab6: 'tab-pane fade ' })

        } else if (vl === 4) {
            setACtiveTab({ tab1: 'rounded nav-link bg-blue-100 text-light', tab2: 'rounded nav-link  bg-blue-200 text-light', tab3: '  nav-link bg-blue-300 text-light', tab4: 'active rounded nav-link bg-blue-400 text-light', tab5: 'rounded nav-link bg-blue-500 text-light', tab6: 'rounded nav-link bg-blue-600 text-light' })
            setTabValid({ tab1: 'false', tab2: 'false', tab3: 'false', tab4: 'true', tab5: 'false', tab6: 'false' })
            setTabPanel({ tab1: 'tab-pane fade ', tab2: 'tab-pane fade ', tab3: 'tab-pane fade', tab6: 'tab-pane fade', tab4: 'tab-pane fade active show', tab5: 'tab-pane fade' })

        } else if (vl === 5) {
            setACtiveTab({ tab1: 'rounded nav-link bg-blue-100 text-light', tab2: 'rounded nav-link  bg-blue-200 text-light', tab3: '  nav-link bg-blue-300 text-light', tab4: ' rounded nav-link bg-blue-400 text-light', tab6: ' rounded nav-link bg-blue-600 text-light', tab5: 'active rounded nav-link bg-blue-500 text-light' })
            setTabValid({ tab1: 'false', tab2: 'false', tab3: 'false', tab4: 'false', tab6: 'false', tab5: 'true' })
            setTabPanel({ tab1: 'tab-pane fade ', tab2: 'tab-pane fade ', tab3: 'tab-pane fade', tab4: 'tab-pane fade', tab6: 'tab-pane fade', tab5: 'tab-pane fade active show' })

        } else if (vl === 6) {
            setACtiveTab({ tab1: 'rounded nav-link bg-blue-100 text-light', tab2: 'rounded nav-link  bg-blue-200 text-light', tab3: '  nav-link bg-blue-300 text-light', tab4: ' rounded nav-link bg-blue-400 text-light', tab5: ' rounded nav-link bg-blue-500 text-light', tab6: 'active rounded nav-link bg-blue-600 text-light' })
            setTabValid({ tab1: 'false', tab2: 'false', tab3: 'false', tab4: 'false', tab5: 'false', tab6: 'true' })
            setTabPanel({ tab1: 'tab-pane fade ', tab2: 'tab-pane fade ', tab3: 'tab-pane fade', tab4: 'tab-pane fade', tab5: 'tab-pane fade', tab6: 'tab-pane fade active show' })

        }



    }

    const gestionarConsejo = (ope, index) => (e) => {
        e.preventDefault();
        setOperacionCon(ope);
        if (ope === 1) {
            setMostrarConsejo(true)
        } else if (ope === 2 || ope === 3) {
            for (let x = 0; x < records.length; x++) {
                if (x === index) {
                    setConsejoPlan(records[x]);
                    setMostrarConsejo(true)
                }
            }
        }
    }

    const onHideConsejo = (value) => {
        setMostrarConsejo(false)
        records.push(value)
    }


    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
        seleccionarOrganizacion();
    }

    const cerrarToast = () => {
        setToast({
            ...toast,
            mostrar: false
        })
    }


    return (
        <div>
            <Mensaje mensaje={mensaje} onHide={() =>
                mensaje.titulo === 'Exito.' ? cerrarModal() :
                setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
            <Dimmer active={activate} inverted></Dimmer>
            <CatalogoPersona show={mostrar3}
                onHideCancelaCatPer={() => { setMostrar3(false) }}
                onHideAceptaCatPer={handleAceptaCatalogoPer}/>
            <div className='p-2'>
                <ul className="nav mb-3" id="ex-with-icons" role="tablist">
                    <li className="nav-item" role="presentation" >
                        <a className={activeTab.tab1} 
                            id="ex-with-icons-tab-1" 
                            type="button" 
                            onClick={tabs(1)} 
                            data-mdb-toggle={tabIndex.tab1} 
                            role="tab" 
                            aria-controls="tab1" 
                            aria-selected={tabvalid.tab1}>
                            <i className="fas fa-chart-pie fa-fw me-2" />
                            Datos Gnr.
                        </a>
                    </li>
                    <li className="nav-item" role="presentation" >
                        <a className={activeTab.tab2} 
                            id="ex-with-icons-tab-2" 
                            type="button" 
                            onClick={tabs(2)} 
                            data-mdb-toggle={tabIndex.tab2} 
                            role="tab" 
                            aria-controls="tab2" 
                            aria-selected={tabvalid.tab2}>
                            <i className="fas fa-chart-line fa-fw me-2" />
                            Responsable
                        </a>
                    </li>
                    <li className="nav-item" role="presentation" >
                        <a className={activeTab.tab3} 
                            id="ex-with-icons-tab-3" 
                            type="button" 
                            onClick={tabs(3)} 
                            data-mdb-toggle={tabIndex.tab3} 
                            role="tab" 
                            aria-controls="tab3" 
                            aria-selected={tabvalid.tab3}>
                            <i className="fas fa-chart-line fa-fw me-2" />
                            Personal Directivo
                        </a>
                    </li>
                    <li className="nav-item" role="presentation" >
                        <a className={activeTab.tab4} 
                            id="ex-with-icons-tab-4" 
                            type="button" 
                            onClick={tabs(4)} 
                            data-mdb-toggle={tabIndex.tab4} 
                            role="tab" 
                            aria-controls="tab4" 
                            aria-selected={tabvalid.tab4}>
                            <i className="fas fa-chart-line fa-fw me-2" />
                            Contraloria
                        </a>
                    </li>
                    <li className="nav-item" role="presentation" >
                        <a className={activeTab.tab5} 
                            id="ex-with-icons-tab-5" 
                            type="button" 
                            onClick={tabs(5)} 
                            data-mdb-toggle={tabIndex.tab5} 
                            role="tab" 
                            aria-controls="tab5" 
                            aria-selected={tabvalid.tab5}>
                            <i className="fas fa-chart-line fa-fw me-2" />
                            Consejo Municipal
                        </a>
                    </li>
                    <li className="nav-item" role="presentation" >
                        <a className={activeTab.tab6} 
                            id="ex-with-icons-tab-6" 
                            type="button" 
                            onClick={tabs(6)} 
                            data-mdb-toggle={tabIndex.tab6} 
                            role="tab" 
                            aria-controls="tab6" 
                            aria-selected={tabvalid.tab6}>
                            <i className="fas fa-chart-line fa-fw me-2" />
                            Consejo Local de Planificación
                        </a>
                    </li>
                </ul>
                <div className="tab-content" 
                    id="ex-with-icons-content">
                    <div className={tabPanel.tab1} 
                        id="tab1" 
                        role="tabpanel" 
                        aria-labelledby="ex-with-icons-tab-1">
                        <div className='col-12 m-0 p-2 rounded d-flex flex-wrap align-items-center justify-content-between bg-light'>
                            <div className="col-2 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Codigo:
                                </label>
                                <input type="text" 
                                    className="form-control text-uppercase" 
                                    disabled 
                                    ref={txtIdOrg}  
                                    onChange={handleInputNumChange} />
                            </div>
                            <div className="col-9 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Razon Social:
                                </label>
                                <input type="text" 
                                    className="form-control text-uppercase" 
                                    disabled={deshabilitado} 
                                    autoComplete='off' 
                                    ref={txtRazonSoc}  
                                    onChange={(e) => { e.target.value = e.target.value.toUpperCase() }}  
                                    id='inputRazonSoc' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} />
                            </div>
                            <div className="col-7 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Nombre:
                                </label>
                                <input type="text" 
                                    className="form-control text-uppercase" 
                                    disabled={deshabilitado} 
                                    autoComplete='off' 
                                    ref={txtNomOrg}  
                                    id='inputNombre' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} 
                                    onChange={(e) => { e.target.value = e.target.value.toUpperCase() }} />
                            </div>
                            <div className="col-3 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >Rif:</label>
                                <select disabled={deshabilitado} ref={cmbRif} className="form-select form-select-sm" id="inputLetraRif" >
                                    <option value="J">J</option>
                                    <option value="V">V</option>
                                    <option value="G">G</option>
                                    <option value="E">E</option>
                                    <option value="P">P</option>
                                </select>
                                <input type="text" disabled={deshabilitado} ref={txtRif} maxLength={14} className="form-control form-control-sm" placeholder="123456789" id="inputRif" onChange={handleInputNumChange} onKeyUp={validarRif} onBlur={validarRif} />
                            </div>
                            <div className="col-12 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >Domicilio:</label>
                                <input type="text" disabled={deshabilitado} ref={txtDomicilio} autoComplete='off' className="form-control text-uppercase"  id='inputDomicilio' onKeyUp={handleInputChange} onBlur={handleInputChange} onChange={(e) => { e.target.value = e.target.value.toUpperCase() }} />
                            </div>
                            <div className="col-3 m-0 mb-2 p-0 pr-2 input-group input-group-sm">
                                <label className="input-group-text" >Estado:</label>
                                <select className="form-select" aria-label="Default select example col-md-4" name='idestado' disabled={deshabilitado} ref={cmbEstado} /*value={valuest && valuest.idestado}*/ onChange={onChange} id="inputFechaReg">
                                    <option value={""}>SELECCIONAR ESTADO</option>
                                    {estado && estado.map((item, index) => (
                                        <option key={index} value={item.idestado} > {item.nombre} </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-3 m-0 mb-2 p-0 pr-2 input-group input-group-sm">
                                <label className="input-group-text" >Municipio:</label>
                                <select className="form-select" aria-label="Default select example col-md-4" name='idmunicipio' disabled={deshabilitado} ref={cmbMunicipio} /*value={valuest && valuest.idmunicipio}*/ onChange={onChange} >
                                    <option value={""}>SELECCIONAR MUNICIPIO</option>
                                    {municipio && municipio.map((item, index) => (
                                        <option key={index} value={item.idmunicipio} > {item.nombre} </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-3 m-0 mb-2 p-0 pr-2 input-group input-group-sm">
                                <label className="input-group-text" >Ciudad:</label>
                                <select className="form-select" aria-label="Default select example col-md-4" name='idciudad' disabled={deshabilitado} ref={cmbCiudad} /*value={valuest && valuest.idciudad}*/ onChange={onChange} >
                                    <option value={""}>SELECCIONAR CIUDAD</option>
                                    {ciudad && ciudad.map((item, index) => (
                                        <option key={index} value={item.idciudad} > {item.nombre} </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-3 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >E-mail:</label>
                                <input type="text" disabled={deshabilitado} ref={txtEmailOrg} autoComplete='off' className="form-control text-uppercase"  id='inputEmailOrg' onKeyUp={handleInputChange} onBlur={handleInputChange} onChange={(e) => { e.target.value = e.target.value.toUpperCase() }} />
                            </div>
                            <div className="col-3 m-0 mb-2 p-0 pr-2 input-group input-group-sm">
                                <label className="input-group-text" >Telefono:</label>
                                <input type="text" disabled={deshabilitado} ref={txtTlfOrg} autoComplete='off' className="form-control text-uppercase"  id='inputTlfOrg' onKeyUp={handleInputChange} onBlur={handleInputChange} onChange={handleInputNumChange} />
                            </div>
                            <div className="col-3 m-0 mb-2 p-0 pr-2 input-group input-group-sm">
                                <label className="input-group-text" >Celular:</label>
                                <input type="text" disabled={deshabilitado} ref={txtCelOrg} autoComplete='off' className="form-control text-uppercase"  id='inputCelOrg' onKeyUp={handleInputChange} onBlur={handleInputChange} onChange={handleInputNumChange} />
                            </div>
                            <div className="col-2 m-0 mb-2 p-0 pr-2 input-group input-group-sm">
                                <label className="input-group-text" >Fax:</label>
                                <input type="text" disabled={deshabilitado} ref={txtFaxOrg} autoComplete='off' className="form-control text-uppercase"  id='inputFaxOrg' onKeyUp={handleInputChange} onBlur={handleInputChange} onChange={(e) => { e.target.value = e.target.value.toUpperCase() }} />
                            </div>
                            <div className="col-4 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text my-auto" >Página Web:</label>
                                <input type="text" disabled={deshabilitado} ref={txtPagWeb} autoComplete='off' className="form-control my-auto"  id='inputPagWeb' onKeyUp={handleInputChange} onBlur={handleInputChange} onChange={(e) => { e.target.value = e.target.value.toUpperCase() }} />
                            </div>
                            <div className="col-12 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Misión:
                                </label>
                                <textarea type="textarea" 
                                    style={{ height: '40px' }} 
                                    disabled={deshabilitado} 
                                    ref={txtMision} 
                                    autoComplete='off' 
                                    className="form-control text-uppercase" 
                                    id='inputMision' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} 
                                    onChange={(e) => { e.target.value = e.target.value.toUpperCase() }} />
                            </div>
                            <div className="col-12 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >Principios:</label>
                                <textarea type="textarea" style={{ height: '40px' }} disabled={deshabilitado} ref={txtPrincipios} autoComplete='off' className="form-control text-uppercase"  id='inputPrincipios' onKeyUp={handleInputChange} onBlur={handleInputChange} onChange={(e) => { e.target.value = e.target.value.toUpperCase() }} />
                            </div>
                            <div className="col-12 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >Visión:</label>
                                <textarea type="textarea" style={{ height: '40px' }} disabled={deshabilitado} ref={txtVision} autoComplete='off' className="form-control text-uppercase"  id='inputVision' onKeyUp={handleInputChange} onBlur={handleInputChange} onChange={(e) => { e.target.value = e.target.value.toUpperCase() }} />
                            </div>
                            <div className="col-6 m-0 mb-2 p-0 input-group input-group-sm`">
                                <label className="input-group-text" >Base Legal:</label>
                                <textarea type="textarea" style={{ height: '40px' }} disabled={deshabilitado} ref={txtBaseL} autoComplete='off' className="form-control text-uppercase"  id='inputVision' onKeyUp={handleInputChange} onBlur={handleInputChange} onChange={(e) => { e.target.value = e.target.value.toUpperCase() }} />
                            </div>
                            <div className="col-3 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text my-auto" >Cód. Presupuestario:</label>
                                <input type="text" disabled={deshabilitado} ref={txtCodPresu} autoComplete='off' className="form-control my-auto"  id='inputPagWeb' onKeyUp={handleInputChange} onBlur={handleInputChange} onChange={handleInputNumChange} />
                            </div>
                            <div className="col-2 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text my-auto" >Código Postal:</label>
                                <input type="text" disabled={deshabilitado} ref={txtCodPostal} autoComplete='off' className="form-control my-auto"  id='inputPagWeb' onKeyUp={handleInputChange} onBlur={handleInputChange} onChange={(e) => { e.target.value = e.target.value.toUpperCase() }} />
                            </div>
                            <fieldset className='col-12 m-0 p-2 border-azul rounded d-flex justify-content-between'>
                                <legend className="float-none w-auto m-0">
                                    Proveedor/Beneficiario
                                </legend>
                                <div className="col-12 m-0 p-0 input-group input-group-sm">
                                    <label className="input-group-text" >
                                        Código:
                                    </label>
                                    <input type="text" 
                                        disabled={deshabilitado} 
                                        autoComplete='off' 
                                        ref={txtCodProv} 
                                        className="form-control col-1"  
                                        onChange={handleInputNumChange} />
                                    <button type="button" 
                                        disabled={deshabilitado} 
                                        className="btn btn-success" >
                                        <i className="fas fa-search"></i>
                                    </button>
                                    <input type="text" 
                                        disabled 
                                        placeholder='Proveedor' 
                                        autoComplete='off' 
                                        ref={txtNomProv} 
                                        className="form-control text-uppercase"  />
                                    <input type="text" 
                                        disabled 
                                        autoComplete='off' 
                                        ref={txtRifProv} 
                                        className="form-control col-3" placeholder='J-0000000-0'  />
                                </div>
                            </fieldset>
                            <div className='col-12 m-0 p-2 gap-2 d-flex justify-content-end'>
                                {data ?
                                    <button type="button" 
                                        disabled={habilitadoBot} 
                                        onClick={editarOrganizacion(2, accorganizacion.toString().substring(2, 3))} 
                                        className={accorganizacion.toString().substring(2, 3) === '1' ? "btn btn-sm btn-warning rounded-pill" : "btn btn-sm btn-secondary rounded-pill"}>
                                        <i className="fas fa-pen-nib"></i>
                                        Modificar
                                    </button>
                                    : <button 
                                        type="button" 
                                        disabled={habilitadoBot} 
                                        onClick={editarOrganizacion(1, '')} className="btn btn-sm btn-primary rounded-pill">
                                        <i className="fas fa-plus"></i>
                                        Registrar
                                    </button>
                                }
                                <button type="button" 
                                    disabled={!habilitadoBot} 
                                    onClick={onChangeValidar} 
                                    ref={btnAcepta} 
                                    className="btn-sm btn btn-success rounded-pill">
                                    <i className="far fa-check-circle"></i>
                                    Aceptar
                                </button>
                                <button type="button" 
                                    disabled={!habilitadoBot} 
                                    onClick={cancelar()} 
                                    className="btn btn-sm btn-danger rounded-pill">
                                    <i className="far fa-times-circle"></i>
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className={tabPanel.tab2} 
                        id="tab2" 
                        role="tabpanel" 
                        aria-labelledby="ex-with-icons-tab-2">
                        <div className='col-12 m-0 p-2 bg-light rounded d-flex flex-wrap align-items-center justify-content-between'>
                            <div className="col-3 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Cedula:
                                </label>
                                <select disabled={!habilitadoNU} 
                                    ref={cmbNacionalidad} 
                                    className="form-select col-4">
                                    <option key="0" value="V">V</option>
                                    <option key="1" value="E">E</option>
                                </select>
                                <input type="text" 
                                    disabled={deshabilitado} 
                                    autoComplete='off' 
                                    ref={txtCedula} 
                                    className="form-control text-uppercase" 
                                    onKeyUp={validarPersona(1)} 
                                    onBlur={validarPersona(1)} 
                                    onChange={handleInputNumChange} />
                                <button type="button" 
                                    disabled={deshabilitado} 
                                    onClick={catalogoPer(1)} 
                                    className="btn btn-success" >
                                    <i className="fas fa-search"></i>
                                </button>
                            </div>
                            <div className='col-7 m-0 mb-2 p-0'></div>
                            <div className="col-2 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Sexo:
                                </label>
                                <select disabled={!habilitadoNU} 
                                    ref={cmbSexo} 
                                    className="form-select" >
                                    <option key="0" value="M">M</option>
                                    <option key="1" value="F">F</option>
                                </select>
                            </div>
                            <div className="col-6 m-0 mb-2 p-0 pr-2 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Nombres:
                                </label>
                                <input type="text" 
                                    disabled={!habilitadoNU} 
                                    autoComplete='off' 
                                    ref={txtNombreRespon} 
                                    className="form-control text-uppercase"  
                                    id='inputNombreRespon' 
                                    name='inputNombreRespon' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} />
                            </div>
                            <div className="col-6 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Apellidos:
                                </label>
                                <input type="text" 
                                    disabled={!habilitadoNU} 
                                    autoComplete='off' 
                                    ref={txtApellidoRespon} 
                                    className="form-control text-uppercase"  
                                    id='inputApellidoRespon' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} />
                            </div>
                            <div className="col-12 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Direccion:
                                </label>
                                <textarea style={{ height: 40 }} 
                                    disabled={!habilitadoNU} 
                                    autoComplete='off' 
                                    ref={txtDireccionRespon} 
                                    className="form-control text-uppercase" 
                                    id="textAreaExample" 
                                    rows="3">
                                </textarea>
                            </div>
                            <div className="col-3 m-0 mb-2 p-0 pr-2 input-group input-group-sm">
                                <label className="input-group-text" >
                                    E-mail:
                                </label>
                                <input type="text" 
                                    disabled={!habilitadoNU} 
                                    autoComplete='off' 
                                    ref={txtEmailRespon} 
                                    className="form-control text-uppercase"  
                                    id='inputEmailRespon' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} />
                            </div>
                            <div className="col-3 m-0 mb-2 p-0 pr-2 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Telefono:
                                </label>
                                <input type="text" 
                                    disabled={!habilitadoNU} 
                                    autoComplete='off' 
                                    ref={txtTlfRespon} 
                                    className="form-control text-uppercase"  
                                    id='inputTlfRespon' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} 
                                    onChange={handleInputNumChange} />
                            </div>
                            <div className="col-3 m-0 mb-2 p-0 pr-2 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Celular:
                                </label>
                                <input type="text" 
                                    disabled={!habilitadoNU} 
                                    autoComplete='off' 
                                    ref={txtCelRespon} 
                                    className="form-control text-uppercase"  
                                    id='inputCelRespon' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} 
                                    onChange={handleInputNumChange} />
                            </div>
                            <div className="col-3 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >Fecha Namiento:</label>
                                <input type="date" 
                                disabled={!habilitadoNU} 
                                ref={txtFechaNac} 
                                max={fechaSistema} 
                                className="form-control text-uppercase"  
                                id='inputFechaNac' 
                                onKeyUp={handleInputChange} 
                                onBlur={handleInputChange} />
                            </div>
                        </div>
                    </div>  
                    <div className={tabPanel.tab3} id="tab3" role="tabpanel">
                        <nav>
                            <div className="nav nav-pills pl-2 mb-2 d-flex align-items-center justify-content-between" id="nav-tab" role='tablist'>
                                <button class="nav-link active p-0 m-0 px-1 py-2" 
                                    id="nav-planificacion" 
                                    data-bs-toggle="tab" 
                                    data-bs-target="#navPlanificacion" 
                                    type="button" 
                                    role="tab" 
                                    aria-controls="navPlanificacion" 
                                    aria-selected="true">
                                    Planificación y/o Presupuesto
                                </button>
                                <button class="nav-link p-0 m-0 px-1 py-2" 
                                    id="nav-administracion" 
                                    data-bs-toggle="tab" 
                                    data-bs-target="#navAdministracion" 
                                    type="button" 
                                    role="tab" 
                                    aria-controls="navAdministracion" 
                                    aria-selected="false">
                                    Administración
                                </button>
                                <button class="nav-link p-0 m-0 px-1 py-2" 
                                    id="nav-recursosHumano" 
                                    data-bs-toggle="tab" 
                                    data-bs-target="#navRecursosHumanos" 
                                    type="button" 
                                    role="tab" 
                                    aria-controls="navRecursosHumanos" 
                                    aria-selected="false">
                                    Recursos Humanos
                                </button>
                                <button class="nav-link p-0 m-0 px-1 py-2" 
                                    id="nav-sindicatura" 
                                    data-bs-toggle="tab" 
                                    data-bs-target="#navSindicatura" 
                                    type="button" 
                                    role="tab" 
                                    aria-controls="navSindicatura" 
                                    aria-selected="false">
                                    Sindicatura
                                </button>
                                <button class="nav-link p-0 m-0 px-1 py-2" 
                                    id="nav-cronista" 
                                    data-bs-toggle="tab" 
                                    data-bs-target="#navCronista" 
                                    type="button" 
                                    role="tab" 
                                    aria-controls="navCronista" 
                                    aria-selected="false">
                                    Cronista del Municipio
                                </button>
                            </div>
                        </nav>
                        <div class="tab-content" id="nav-tabContent">
                            <div class="tab-pane fade show active" 
                                id="navPlanificacion" 
                                role="tabpanel" 
                                aria-labelledby="nav-planificacion" 
                                tabindex="0">
                                <div className='col-12 m-0 p-2 bg-light rounded d-flex flex-wrap align-items-center justify-content-between'>
                                    <div className="col-3 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Cedula:
                                        </label>
                                        <select disabled 
                                            ref={cmbNacPresu} 
                                            className="form-select col-md-3" >
                                            <option key="0" value="V">V</option>
                                            <option key="1" value="E">E</option>
                                        </select>
                                        <input type="text" 
                                            disabled={deshabilitado} 
                                            ref={txtCedulaPresupuesto} 
                                            defaultValue={presupuesto.cedula !== '' ? presupuesto.cedula : ''} 
                                            autoComplete='off' 
                                            className="form-control text-uppercase"  
                                            onKeyUp={validarPersona(2)} 
                                            onBlur={validarPersona(2)} 
                                            onChange={handleInputNumChange} />
                                        <button type="button" 
                                            disabled={deshabilitado} 
                                            onClick={catalogoPer(2)} 
                                            className="btn btn-success" >
                                            <i className="fas fa-search"></i>
                                        </button>
                                    </div>
                                    <div className='col-6 m-0 p-0'></div>
                                    <div className="col-2 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >Sexo:</label>
                                        <select disabled ref={cmbSexPresu} className="form-select" >
                                            <option key="0" value="M">M</option>
                                            <option key="1" value="F">F</option>
                                        </select>
                                    </div>
                                    <div className="col-6 m-0 mb-2 p-0 pr-2 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Nombres:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={presupuesto.nombres !== '' ? presupuesto.nombres : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputNombreRespon' 
                                            name='inputNombreRespon' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-6 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Apellidos:
                                        </label> 
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={presupuesto.apellidos !== '' ? presupuesto.apellidos : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputApellidoRespon' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-12 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Direccion:
                                        </label>
                                        <textarea style={{ height: 40 }} 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={presupuesto.direccion !== '' ? presupuesto.direccion : ''} 
                                            className="form-control text-uppercase" 
                                            id="textAreaExample" 
                                            rows="3">
                                        </textarea>
                                    </div>
                                    <div className="col-4 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            E-mail:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={presupuesto.correoe !== '' ? presupuesto.correoe : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputEmailRespon' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-2 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Telefono:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={presupuesto.tlf1 !== '' ? presupuesto.tlf1 : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputTlfRespon' 
                                            onChange={handleInputNumChange} 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-2 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Celular:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={presupuesto.tlf2 !== '' ? presupuesto.tlf2 : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputCelRespon' 
                                            onChange={handleInputNumChange} 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} /> 
                                    </div>
                                    <div className="col-3 m-0 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Fecha Namiento:
                                        </label>
                                        <input type="date" 
                                            disabled 
                                            defaultValue={presupuesto.fnacimiento !== '' ? moment.utc(presupuesto.fnacimiento).format('YYYY-MM-DD') : ''} 
                                            max={fechaSistema} 
                                            className="form-control text-uppercase"  
                                            id='inputFechaNac' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" 
                                id="navAdministracion" 
                                role="tabpanel" 
                                aria-labelledby="nav-administracion" 
                                tabindex="0">
                                <div className='col-12 m-0 p-2 bg-light rounded d-flex flex-wrap align-items-center justify-content-between'>
                                    <div className="col-3 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Cedula:
                                        </label>
                                        <select disabled 
                                            ref={cmbNacAdmin} 
                                            className="form-select col-md-3" >
                                            <option key="0" value="V">V</option>
                                            <option key="1" value="E">E</option>
                                        </select>
                                        <input type="text" 
                                            disabled={deshabilitado} 
                                            ref={txtCedulaAministracion} 
                                            defaultValue={administracion.cedula !== '' ? administracion.cedula : ''} 
                                            autoComplete='off' 
                                            className="form-control text-uppercase"  
                                            onChange={handleInputNumChange} 
                                            onKeyUp={validarPersona(3)} 
                                            onBlur={validarPersona(3)} />
                                        <button type="button" 
                                            disabled={deshabilitado} 
                                            onClick={catalogoPer(3)} 
                                            className="btn btn-success" >
                                            <i className="fas fa-search"></i>
                                        </button>
                                    </div>
                                    <div className='col-7 m-0 mb-2 p-0'></div>
                                    <div className="col-2 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Sexo:
                                        </label>
                                        <select disabled 
                                            ref={cmbSexAdmin} 
                                            defaultValue={administracion.nacionalidad !== '' ? administracion.nacionalidad : ''} 
                                            className="form-select" >
                                            <option key="0" value="M">M</option>
                                            <option key="1" value="F">F</option>
                                        </select>
                                    </div>
                                    <div className="col-6 m-0 mb-2 p-0 pr-2 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Nombres:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={administracion.nombres !== '' ? administracion.nombres : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputNombreRespon' 
                                            name='inputNombreRespon' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-6 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Apellidos:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={administracion.apellidos !== '' ? administracion.apellidos : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputApellidoRespon' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-12 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Direccion:
                                        </label>
                                        <textarea style={{ height: 40 }} 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={administracion.direccion !== '' ? administracion.direccion : ''} 
                                            className="form-control text-uppercase" 
                                            id="textAreaExample" 
                                            rows="3">
                                        </textarea>
                                    </div>
                                    <div className="col-3 m-0 p-0 pr-2 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            E-mail:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={administracion.correoe !== '' ? administracion.correoe : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputEmailRespon' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-3 m-0 p-0 pr-2 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Telefono:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            onChange={handleInputNumChange} 
                                            defaultValue={administracion.tlf1 !== '' ? administracion.tlf1 : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputTlfRespon' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-3 m-0 p-0 pr-2 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Celular:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            onChange={handleInputNumChange} 
                                            defaultValue={administracion.tlf2 !== '' ? administracion.tlf2 : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputCelRespon' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-3 m-0 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Fecha Namiento:
                                        </label>
                                        <input type="date" 
                                            disabled 
                                            defaultValue={administracion.fnacimiento !== '' ? moment.utc(administracion.fnacimiento).format('YYYY-MM-DD') : ''} 
                                            max={fechaSistema} 
                                            className="form-control text-uppercase"  
                                            id='inputFechaNac' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" 
                                id="navRecursosHumanos" 
                                role="tabpanel" 
                                aria-labelledby="nav-recursosHumanos" 
                                tabindex="0">
                                <div className='col-12 m-0 p-2 bg-light rounded d-flex flex-wrap align-items-center'>
                                    <div className="col-3 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Cedula:
                                        </label>
                                        <select disabled 
                                            ref={cmbNacRecur} 
                                            className="form-select col-3" >
                                            <option key="0" value="V">V</option>
                                            <option key="1" value="E">E</option>
                                        </select>
                                        <input type="text" 
                                            disabled={deshabilitado} 
                                            ref={txtCedulaRRHH} 
                                            defaultValue={recursos.cedula !== '' ? recursos.cedula : ''} 
                                            autoComplete='off' 
                                            className="form-control text-uppercase"  
                                            onChange={handleInputNumChange} 
                                            onKeyUp={validarPersona(4)} 
                                            onBlur={validarPersona(4)} />
                                        <button type="button" 
                                            disabled={deshabilitado} 
                                            onClick={catalogoPer(4)} 
                                            className="btn btn-success" >
                                            <i className="fas fa-search"></i>
                                        </button>
                                    </div>
                                    <div className='col-7 m-0 mb-2 p-0'></div>
                                    <div className="col-2 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Sexo:
                                        </label>
                                        <select disabled 
                                            ref={cmbSexRecur} 
                                            className="form-select" >
                                            <option key="0" value="M">M</option>
                                            <option key="1" value="F">F</option>
                                        </select>
                                    </div>
                                    <div className="col-6 m-0 mb-2 p-0 pr-2 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Nombres:
                                        </label>
                                        <input type="text" 
                                            disabled autoComplete='off' 
                                            defaultValue={recursos.nombres !== '' ? recursos.nombres : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputNombreRespon' 
                                            name='inputNombreRespon' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-6 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text">
                                            Apellidos:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={recursos.apellidos !== '' ? recursos.apellidos : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputApellidoRespon' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-12 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Direccion:
                                        </label>
                                        <textarea style={{ height: 40 }} 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={recursos.direccion !== '' ? recursos.direccion : ''} 
                                            className="form-control text-uppercase" 
                                            id="textAreaExample" 
                                            rows="3">
                                        </textarea>
                                    </div>
                                    <div className="col-3 m-0 p-0 pr-2 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            E-mail:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={recursos.correoe !== '' ? recursos.correoe : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputEmailRespon' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-3 m-0 p-0 pr-2 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Telefono:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={recursos.tlf1 !== '' ? recursos.tlf1 : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputTlfRespon' 
                                            onKeyUp={handleInputChange} 
                                            onChange={handleInputNumChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-3 m-0 p-0 pr-2 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Celular:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={recursos.tlf2 !== '' ? recursos.tlf2 : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputCelRespon' 
                                            onKeyUp={handleInputChange} 
                                            onChange={handleInputNumChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-3 m-0 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Fecha Namiento:
                                        </label>
                                        <input type="date" 
                                            disabled 
                                            defaultValue={recursos.fnacimiento !== '' ? moment.utc(recursos.fnacimiento).format('YYYY-MM-DD') : ''} 
                                            max={fechaSistema} 
                                            className="form-control text-uppercase"  
                                            id='inputFechaNac' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" 
                                id="navSindicatura" 
                                role="tabpanel" 
                                aria-labelledby="nav-sindicatura" 
                                tabindex="0">
                                <div className='col-12 m-0 p-2 bg-light rounded d-flex flex-wrap align-items-center'>
                                    <div className="col-3 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Cedula:
                                        </label>
                                        <select disabled 
                                            ref={cmbNacSindi} 
                                            className="form-select col-3" >
                                            <option key="0" value="V">V</option>
                                            <option key="1" value="E">E</option>
                                        </select>
                                        <input type="text" 
                                            disabled={deshabilitado} 
                                            ref={txtCedulaSindico} 
                                            defaultValue={sindicato.cedula !== '' ? sindicato.cedula : ''} 
                                            autoComplete='off' 
                                            className="form-control text-uppercase"  
                                            onKeyUp={validarPersona(5)} 
                                            onBlur={validarPersona(5)} 
                                            onChange={handleInputNumChange} />
                                        <button type="button" 
                                            disabled={deshabilitado} 
                                            onClick={catalogoPer(5)} 
                                            className="btn btn-success" >
                                            <i className="fas fa-search"></i>
                                        </button>
                                    </div>
                                    <div className='col-7 m-0 mb-2 p-0'></div>
                                    <div className="col-2 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Sexo:
                                        </label>
                                        <select disabled    
                                            ref={cmbSexSindi} 
                                            className="form-select" >
                                            <option key="0" value="M">M</option>
                                            <option key="1" value="F">F</option>
                                        </select>
                                    </div>
                                    <div className="col-6 m-0 mb-2 p-0 pr-2 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Nombres:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={sindicato.nombres !== '' ? sindicato.nombres : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputNombreRespon' 
                                            name='inputNombreRespon' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-6 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Apellidos:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={sindicato.apellidos !== '' ? sindicato.apellidos : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputApellidoRespon' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-12 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Direccion:
                                        </label>
                                        <textarea style={{ height: 40 }} 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={sindicato.direccion !== '' ? sindicato.direccion : ''} 
                                            className="form-control text-uppercase" 
                                            id="textAreaExample" 
                                            rows="3">
                                        </textarea>
                                    </div>
                                    <div className="col-3 m-0 p-0 pr-2 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            E-mail:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={sindicato.correoe !== '' ? sindicato.correoe : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputEmailRespon' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-3 m-0 p-0 pr-2 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Telefono:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={sindicato.tlf1 !== '' ? sindicato.tlf1 : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputTlfRespon' 
                                            onChange={handleInputNumChange} 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-3 m-0 p-0 pr-2 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Celular:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={sindicato.tlf2 !== '' ? sindicato.tlf2 : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputCelRespon' 
                                            onChange={handleInputNumChange} 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-3 m-0 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Fecha Namiento:
                                        </label>
                                        <input type="date" 
                                            disabled 
                                            defaultValue={sindicato.fnacimiento !== '' ? moment.utc(sindicato.fnacimiento).format('YYYY-MM-DD') : ''} 
                                            max={fechaSistema} 
                                            className="form-control text-uppercase"  
                                            id='inputFechaNac' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" 
                                id="navCronista" 
                                role="tabpanel" 
                                aria-labelledby="nav-cronista" 
                                tabindex="0">
                                <div className='col-12 m-0 p-2 bg-light rounded d-flex flex-wrap align-items-center'>
                                    <div className="col-3 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Cedula:
                                        </label>
                                        <select disabled 
                                            ref={cmbNacCroni} 
                                            className="form-select col-md-3" >
                                            <option key="0" value="V">V</option>
                                            <option key="1" value="E">E</option>
                                        </select>
                                        <input type="text" 
                                            disabled={deshabilitado} 
                                            ref={txtCedulaCronista} 
                                            defaultValue={cronista.cedula !== '' ? cronista.cedula : ''} 
                                            autoComplete='off' 
                                            className="form-control text-uppercase"  
                                            onKeyUp={validarPersona(6)} 
                                            onBlur={validarPersona(6)} 
                                            onChange={handleInputNumChange} />
                                        <button type="button" 
                                            disabled={deshabilitado} 
                                            onClick={catalogoPer(6)} 
                                            className="btn btn-success" >
                                            <i className="fas fa-search"></i>
                                        </button>
                                    </div>
                                    <div className='col-7 m-0 mb-2 p-0'></div>
                                    <div className="col-2 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Sexo:
                                        </label>
                                        <select disabled 
                                            ref={cmbSexCroni} 
                                            className="form-select" >
                                            <option key="0" value="M">M</option>
                                            <option key="1" value="F">F</option>
                                        </select>
                                    </div>
                                    <div className="col-6 m-0 mb-2 p-0 pr-2 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Nombres:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={cronista.nombres !== '' ? cronista.nombres : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputNombreRespon' 
                                            name='inputNombreRespon' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-6 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Apellidos:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={cronista.apellidos !== '' ? cronista.apellidos : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputApellidoRespon' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-12 m-0 mb-2 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Direccion:
                                        </label>
                                        <textarea style={{ height: 40 }} 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={cronista.direccion !== '' ? cronista.direccion : ''} 
                                            className="form-control text-uppercase" 
                                            id="textAreaExample" 
                                            rows="3">
                                        </textarea>
                                    </div>
                                    <div className="col-3 m-0 p-0 pr-2 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            E-mail:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={cronista.correoe !== '' ? cronista.correoe : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputEmailRespon' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-3 m-0 p-0 pr-2 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Telefono:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={cronista.tlf1 !== '' ? cronista.tlf1 : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputTlfRespon' 
                                            onChange={handleInputNumChange} 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-3 m-0 p-0 pr-2 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Celular:
                                        </label>
                                        <input type="text" 
                                            disabled 
                                            autoComplete='off' 
                                            defaultValue={cronista.tlf2 !== '' ? cronista.tlf2 : ''} 
                                            className="form-control text-uppercase"  
                                            id='inputCelRespon' 
                                            onChange={handleInputNumChange} 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                    <div className="col-3 m-0 p-0 input-group input-group-sm">
                                        <label className="input-group-text" >
                                            Fecha Namiento:
                                        </label>
                                        <input type="date" 
                                            disabled 
                                            defaultValue={cronista.fnacimiento !== '' ? moment.utc(cronista.fnacimiento).format('YYYY-MM-DD') : ''} 
                                            max={fechaSistema} 
                                            className="form-control text-uppercase"  
                                            id='inputFechaNac' 
                                            onKeyUp={handleInputChange} 
                                            onBlur={handleInputChange} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={tabPanel.tab4} 
                        id="tab4" 
                        role="tabpanel" 
                        aria-labelledby="ex-with-icons-tab-4">
                        <div className='col-12 m-0 p-2 bg-light rounded d-flex flex-wrap align-items-center justify-content-between'>
                            <div className="col-6 m-0 mb-2 p-0 pr-2 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Nombres:
                                </label>
                                <input type="text" 
                                    disabled={deshabilitado} 
                                    autoComplete='off' 
                                    ref={txtNomContra} 
                                    className="form-control text-uppercase"  
                                    id='inputNombreRespon' 
                                    name='inputNombreRespon' 
                                    onChange={(e) => { e.target.value = e.target.value.toUpperCase() }} />
                            </div>
                            <div className="col-6 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Apellidos:
                                </label>
                                <input type="text" 
                                    disabled={deshabilitado} 
                                    autoComplete='off' 
                                    ref={txtApeContra} 
                                    className="form-control text-uppercase" 
                                    onChange={(e) => { e.target.value = e.target.value.toUpperCase() }} 
                                    id='inputApellidoRespon' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} />
                            </div>
                            <div className="col-12 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Domicilio Legal:
                                </label>
                                <textarea style={{ height: 40 }} 
                                    disabled={deshabilitado} 
                                    autoComplete='off' 
                                    onChange={(e) => { e.target.value = e.target.value.toUpperCase() }} 
                                    ref={txtDomiContra} 
                                    className="form-control text-uppercase" 
                                    id="textAreaExample" 
                                    rows="3">
                                </textarea>
                            </div>
                            <div className="col-4 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    E-mail:
                                </label>
                                <input type="text" 
                                    disabled={deshabilitado} 
                                    autoComplete='off' 
                                    ref={txtCorreContra} 
                                    className="form-control text-uppercase"  
                                    onChange={(e) => { e.target.value = e.target.value.toUpperCase() }}  
                                    id='inputEmailRespon' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} />
                            </div>
                            <div className="col-3 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Telefono:
                                </label>
                                <input type="text" 
                                    disabled={deshabilitado} 
                                    autoComplete='off' 
                                    ref={txtTlfContra} 
                                    className="form-control text-uppercase"  
                                    id='inputTlfRespon' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} 
                                    onChange={handleInputNumChange} />
                            </div>
                            <div className="col-2 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Fax:
                                </label>
                                <input type="text" 
                                    disabled={deshabilitado} 
                                    autoComplete='off' 
                                    ref={txtFaxContra} 
                                    className="form-control text-uppercase"  
                                    id='inputTlfRespon' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} />
                            </div>
                            <div className="col-5 m-0 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Página Web:
                                </label>
                                <input type="text" 
                                    disabled={deshabilitado} 
                                    autoComplete='off' 
                                    ref={txtPagWebContra} 
                                    className="form-control text-uppercase"
                                    onChange={(e) => { e.target.value = e.target.value.toUpperCase() }}  
                                    id='inputTlfRespon' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} />
                            </div>
                        </div>
                    </div>
                    <div className={tabPanel.tab5} 
                        id="tab5" 
                        role="tabpanel" 
                        aria-labelledby="ex-with-icons-tab-5">
                        <div className='col-12 m-0 p-2 bg-light rounded d-flex flex-wrap align-items-center justify-content-between'>
                            <div className="col-6 m-0 mb-2 p-0 pr-2 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Nombres Presidente:
                                </label>
                                <input type="text" 
                                    disabled={deshabilitado} 
                                    autoComplete='off' 
                                    ref={txtNomPre} 
                                    className="form-control text-uppercase"  
                                    id='inputNombreRespon' 
                                    onChange={(e) => { e.target.value = e.target.value.toUpperCase() }} 
                                    name='inputNombreRespon' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} />
                            </div>
                            <div className="col-6 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Apellidos Presidente:
                                </label>
                                <input type="text" 
                                    disabled={deshabilitado} 
                                    autoComplete='off' 
                                    ref={txtApePre} 
                                    className="form-control text-uppercase"  
                                    onChange={(e) => { e.target.value = e.target.value.toUpperCase() }}  
                                    id='inputApellidoRespon' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} />
                            </div>
                            <div className="col-6 m-0 mb-2 p-0 pr-2 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Nombres Secretario:
                                </label>
                                <input type="text" 
                                    disabled={deshabilitado} 
                                    autoComplete='off' 
                                    ref={txtNomSecr} 
                                    className="form-control text-uppercase"  
                                    id='inputNombreRespon' 
                                    onChange={(e) => { e.target.value = e.target.value.toUpperCase() }} 
                                    name='inputNombreRespon' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} />
                            </div>
                            <div className="col-6 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Apellidos Secretario:
                                </label>
                                <input type="text" 
                                    disabled={deshabilitado} 
                                    autoComplete='off' 
                                    ref={txtApeSecr} 
                                    className="form-control text-uppercase"  
                                    onChange={(e) => { e.target.value = e.target.value.toUpperCase() }}  
                                    id='inputApellidoRespon' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} />
                            </div>
                            <div className="col-12 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Domicilio Legal:
                                </label>
                                <textarea style={{ height: 40 }} 
                                    disabled={deshabilitado} 
                                    autoComplete='off' 
                                    onChange={(e) => { e.target.value = e.target.value.toUpperCase() }} 
                                    ref={txtDomiMunicipal} 
                                    className="form-control text-uppercase" 
                                    id="textAreaExample" 
                                    rows="3">
                                </textarea>
                            </div>
                            <div className="col-4 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    E-mail:
                                </label>
                                <input type="text" 
                                    disabled={deshabilitado} 
                                    autoComplete='off' 
                                    onChange={(e) => { e.target.value = e.target.value.toUpperCase() }} 
                                    ref={txtCorreMunicipal} 
                                    className="form-control text-uppercase"  
                                    id='inputEmailRespon' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} />
                            </div>
                            <div className="col-3 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Telefono:
                                </label>
                                <input type="text" 
                                    disabled={deshabilitado} 
                                    autoComplete='off' 
                                    ref={txtTlfMunicipal} 
                                    className="form-control text-uppercase"  
                                    id='inputTlfRespon' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} 
                                    onChange={handleInputNumChange} />
                            </div>
                            <div className="col-3 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Fax:
                                </label>
                                <input type="text" 
                                    disabled={deshabilitado} 
                                    autoComplete='off' 
                                    ref={txtFaxMunicipal} 
                                    className="form-control text-uppercase" 
                                    id='inputTlfRespon' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} />
                            </div>
                            <div className="col-5 m-0 mb-2 p-0 input-group input-group-sm">
                                <label className="input-group-text" >
                                    Página Web:
                                </label>
                                <input type="text" 
                                    disabled={deshabilitado} 
                                    autoComplete='off' 
                                    onChange={(e) => { e.target.value = e.target.value.toUpperCase() }} 
                                    ref={txtPagMunicipal} 
                                    className="form-control text-uppercase"  
                                    id='inputTlfRespon' 
                                    onKeyUp={handleInputChange} 
                                    onBlur={handleInputChange} />
                            </div>
                        </div>
                    </div>
                    <div className={tabPanel.tab6} id="tab6" role="tabpanel" aria-labelledby="ex-with-icons-tab-6">
                        <div className="card px-3 py-2">
                            <div className="col-md-12 row m-0 ">
                                <div className="col-md-1 ml-auto">
                                    <button onClick={gestionarConsejo(1, '')} 
                                        className="btn btn-sm btn-primary rounded-circle">
                                        <i className="fas fa-plus"></i> 
                                    </button>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <TblContainer >
                                    <TblHead />
                                    <tbody>
                                        {
                                            records && recordsAfterPagingAndSorting().map((item, index) => (
                                                <tr key={index} style={{ padding: "0" }}>
                                                    <td className='align-baseline' style={{ textAlign: "center", width: "40%" }}>{item.nombreconsejero}</td>
                                                    <td className='align-baseline' style={{ textAlign: "center", width: "40%" }}>{item.apellidoconsejero}</td>
                                                    <td className='align-baseline' style={{ textAlign: "center", width: '90px' }}>
                                                        <button onClick={gestionarConsejo(2, index)} className="btn btn-sm mx-1 btn-warning rounded-circle"><i className="fa fa-edit"></i> </button>
                                                        <button onClick={gestionarConsejo(3, index)} className="btn btn-sm mx-1 btn-danger rounded-circle"><i className="fa fa-trash"></i> </button>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </TblContainer>
                                <TblPagination />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Mensaje mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono:    '' })} />
            <AgregarConsejo show={mostrarConsejo}
                onHideCancela={() => { setMostrarConsejo(false) }}
                operacion={operacionCon}
                operacionconfig={operacion}
                aceptarConsejo={onHideConsejo}
                idorganizacion={idOrganizacion}
                renderizar={selectConsePlanificacion}
                consejero={consejoPlan}/>

            <Toasts show={toast.mostrar}
                titulo={toast.titulo}
                mensaje={toast.mensaje}
                onHideCancela={cerrarToast}/>
        </div>

    );
}